import styled from 'styled-components';
import { ChannelContext } from "../../../context/channel";
import React from 'react';
import { t } from 'i18next';
import ExitModalIcon from '../Icons/ExitModalIcon';
import Button from '../button/Button';
import colors from '../../../theme/colors';

interface IConfirmPublicationModal {
    setIsShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    linkWL: string;
    handlePublish: () => void;
}

const ModalWrapper = styled.div`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    background-color: rgba(0, 0, 0, 0.6);
`;

const ModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 28px;
    width: 576px;
    height: auto;
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 10px;
`;

const ButtonsContainerContainer = styled.div`
    display: flex;
    justify-content: center;
    margin: 32px 0;
`;

const ModalTitle = styled.h1`
    color: ${(props) => props.theme.colors.title};
    font-size: 28px;
    font-weight: 700;
    margin-top: 36px;
`;

const ShowLink = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    .link-description{
        font-size: 12px;
    }
    .link {
        font-size: 12px;
        font-weight: 700;
    }
`;

const ModalText = styled.span``;

const ConfirmPublicationModal: React.FC<IConfirmPublicationModal> = ({setIsShowModal, linkWL, handlePublish}) => {
    const { channel } = React.useContext(ChannelContext);

    return (
        <ModalWrapper>
            <ModalContainer>
                <ExitModalIcon onClick={() => setIsShowModal(false)} style={{justifyContent: 'flex-end', cursor: 'pointer' }} />
                <ModalTitle>{t('dashboard.modal.publishChanges.title')}</ModalTitle>
                <ModalText>{t('dashboard.modal.publishChanges.text')}</ModalText>
                <ButtonsContainerContainer>
                    <Button
                        onClick={() => setIsShowModal(false)}
                        enable
                        variant='outlined'
                        colorType='white'
                        colorFont='body'
                        style={{
                            borderRadius:'40px',
                            whidth:'108px',
                            height:'46px',
                            border:`1px solid ${colors.border}`,
                        }}
                    >
                        {t('dashboard.modal.publishChanges.cancel')}
                    </Button>
                    <Button
                        onClick={handlePublish}
                        enable
                        style={{
                            borderRadius:'40px',
                            whidth:'108px',
                            height:'46px',
                        }}
                    >
                        {t('dashboard.modal.publishChanges.confirm')}
                    </Button>
                </ButtonsContainerContainer>
                <ShowLink>
                   <span className='link-description'>{t('dashboard.modal.publishChanges.success')}</span>
                   <a href={linkWL} className="link">{linkWL}</a>
                </ShowLink>
                
            </ModalContainer>
        </ModalWrapper>
    )
}

export default ConfirmPublicationModal;
